// CREATE DISCOVER PLACE
export const CREATE_DISCOVER_PLACE = 'CREATE_DISCOVER_PLACE';
export const CREATE_DISCOVER_PLACE_SUCCESS = 'CREATE_DISCOVER_PLACE_SUCCESS';
export const CREATE_DISCOVER_PLACE_FAILED = 'CREATE_DISCOVER_PLACE_FAILED';

// GET DISCOVER PLACE LIST
export const GET_DISCOVER_PLACE_LIST = 'GET_DISCOVER_PLACE_LIST';
export const GET_DISCOVER_PLACE_LIST_SUCCESS = 'GET_DISCOVER_PLACE_LIST_SUCCESS';
export const GET_DISCOVER_PLACE_LIST_FAILED = 'GET_DISCOVER_PLACE_LIST_FAILED';
export const CLEANUP_DISCOVER_PLACE_LIST = 'CLEANUP_DISCOVER_PLACE_LIST';

// DELETE DISCOVER PLACE
export const DELETE_DISCOVER_PLACE = 'DELETE_DISCOVER_PLACE';
export const DELETE_DISCOVER_PLACE_SUCCESS = 'DELETE_DISCOVER_PLACE_SUCCESS';
export const DELETE_DISCOVER_PLACE_FAILED = 'DELETE_DISCOVER_PLACE_FAILED';

// GET DISCOVER PLACE DETAILS
export const GET_DISCOVER_PLACE_DETAILS = 'GET_DISCOVER_PLACE_DETAILS';
export const GET_DISCOVER_PLACE_DETAILS_SUCCESS = 'GET_DISCOVER_PLACE_DETAILS_SUCCESS';
export const GET_DISCOVER_PLACE_DETAILS_FAILED = 'GET_DISCOVER_PLACE_DETAILS_FAILED';
export const CLEANUP_DISCOVER_PLACE_DETAILS = 'CLEANUP_DISCOVER_PLACE_DETAILS';

// UPDATE DISCOVER PLACE
export const UPDATE_DISCOVER_PLACE = 'UPDATE_DISCOVER_PLACE';
export const UPDATE_DISCOVER_PLACE_SUCCESS = 'UPDATE_DISCOVER_PLACE_SUCCESS';
export const UPDATE_DISCOVER_PLACE_FAILED = 'UPDATE_DISCOVER_PLACE_FAILED';
